import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function HeroSection() {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-10 px-6 py-12 lg:grid-cols-12 lg:py-16">
        <div className="lg:col-span-7">
          <p className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600">
            <span className="h-3 w-1 rounded-full bg-primary-500" />
            内容门户 · 站点导览
          </p>
          <h1 className="mt-4 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
            51爆料网
            <span className="mt-2 block text-2xl font-bold text-foreground-700 md:text-4xl">
              栏目导航与内容板块入口
            </span>
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-foreground-600">
            把分散的信息重新组织成清晰的查找路径：首页栏目、专题频道与内容板块入口一页汇总。
            想直接看深度调查、实时热点或某个具体事件，先到栏目导航页定位板块，会比逐页翻找更快。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/lanmu"
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-compass-3-line text-lg" />
              进入栏目导航
            </Link>
            <Link
              to="/pindao/shen-du-diao-cha"
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-accent-300 hover:text-accent-800"
            >
              <i className="ri-search-eye-line text-lg" />
              浏览深度调查
            </Link>
          </div>

          <dl className="mt-9 grid grid-cols-2 gap-x-6 gap-y-5 sm:grid-cols-4">
            {siteInfo.stats.map((stat) => (
              <div key={stat.label} className="border-l-2 border-primary-300 pl-3">
                <dt className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                  {stat.value}
                </dt>
                <dd className="mt-1 text-xs text-foreground-500">{stat.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="lg:col-span-5">
          <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <div className="relative h-44 w-full overflow-hidden bg-background-200 sm:h-52">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20warm%20cream%20paper%20layers%2C%20newspaper%20grid%20lines%20and%20a%20vermillion%20circle%20accent%2C%20minimal%20modern%20magazine%20cover%20art%2C%20muted%20warm%20tones&width=1000&height=640&seq=portal-hero-visual&orientation=landscape"
                alt="51爆料网栏目导航与内容门户的抽象编辑插画"
                title="51爆料网 内容门户与栏目导航"
                className="h-full w-full object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent" />
              <div className="absolute bottom-4 left-4 right-4">
                <p className="text-xs font-medium text-background-100">本站核心入口</p>
                <p className="mt-1 font-heading text-lg font-bold text-background-50">
                  一页看清所有内容板块
                </p>
              </div>
            </div>
            <div className="grid grid-cols-2 divide-x divide-background-200 border-t border-background-200">
              <div className="p-4">
                <p className="flex items-center gap-1.5 text-xs text-foreground-500">
                  <i className="ri-apps-2-line text-accent-600" />
                  栏目总数
                </p>
                <p className="mt-1.5 font-heading text-xl font-bold text-foreground-950">8 个</p>
              </div>
              <div className="p-4">
                <p className="flex items-center gap-1.5 text-xs text-foreground-500">
                  <i className="ri-links-line text-primary-600" />
                  入口分组
                </p>
                <p className="mt-1.5 font-heading text-xl font-bold text-foreground-950">3 类</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}